import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { Message } from '@mui/icons-material';

export default function ReceptionCommunications() {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Comunicări</Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Message sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">SMS, Email, WhatsApp</Typography>
      </Paper>
    </Box>
  );
}
